"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const tariffCurrent = (0, graphql_tag_1.default)`
  query tariff_current {
    tariff {
      current {
        code
        name
        price
        dateEnd
        isRenewable
        trialOn
        trialPossible
        pollTemplatesPossible
        meetingTemplatesPossible
        bulletinCustomizationPossible
        petitionPossible
        pretensionPossible
        buyable
        frozenUnitAmount
        paymentCard {
          id
          dateExpiration
          last4
          vendor
          isDefault
        }
        limits {
          limitType
          availableAmount
          spentAmount
          remainAmount
        }
      }
    }
  }
`;
exports.default = tariffCurrent;